<!-- <p>audiostreaming-list works!</p> -->
<div class="main-content" *ngIf="!isDetailWindowMode">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <app-progress-bar [progress]="progress" (progressUpdated)="onProgressUpdate($event)"></app-progress-bar>
                <div class='card'></div>
                <div class="card-header card-header-rose card-header-icon"
                    style="margin-bottom: -20px;margin-top: 5px;padding: revert;">
                    <div class="recording-toolbar-row">
                        <div class="recording-toolbar-item">
                            <p class="recording-toolbar-label">Department</p>
                            <div class="recording-toolbar-control" style="cursor: pointer;">
                                <jqxDropDownList #myDropDownList [theme]="'material'"
                                    [source]="departmentDropdownOptions" [displayMember]="'label'"
                                    [valueMember]="'value'" [selectedIndex]="0" [width]="350" [height]="30"
                                    [dropDownHeight]="200" [autoDropDownHeight]="false" [filterable]="true"
                                    [filterPlaceHolder]="'Search departments...'"
                                    (onSelect)="departmentChangeEvent($event)" id="department-list-dropdown">
                                </jqxDropDownList>
                            </div>
                        </div>
                        <div class="recording-toolbar-item">
                            <p class="recording-toolbar-label">Source</p>
                            <div class="recording-toolbar-control" style="cursor: pointer;">
                                <jqxDropDownList aria-hidden="true" #myDropDownList [theme]="'material'"
                                    (onSelect)="onRecorcingSourceChange($event)" height.auto [autoDropDownHeight]="true"
                                    [width]="150" [height]="30" [source]="recorcingSources" [selectedIndex]="0"
                                    id="joblist-status-dropdown">
                                </jqxDropDownList>
                            </div>
                        </div>
                        <div class="recording-toolbar-item">
                            <p class="recording-toolbar-label">Status</p>
                            <div class="recording-toolbar-control" style="cursor: pointer;">
                                <jqxDropDownList aria-hidden="true" #myDropDownList [theme]="'material'"
                                    (onSelect)="onStatusChange($event)" height.auto [autoDropDownHeight]="true"
                                    [width]="150" [height]="30" [source]="status" [selectedIndex]="0"
                                    id="joblist-status-dropdown">
                                </jqxDropDownList>
                            </div>
                        </div>
                        <div class="recording-toolbar-item">
                            <p class="recording-toolbar-label">Created</p>
                            <div class="recording-toolbar-control" style="cursor: pointer;">
                                <jqxDropDownList aria-hidden="true" #myDateDropDownList [theme]="'material'"
                                    (onSelect)="onDateOptionChange($event)" style="margin-right: 10px;" height.auto
                                    [autoDropDownHeight]="true" [width]="170" [height]="30" [source]="dateOptions"
                                    [selectedIndex]="selectedIndex">
                                </jqxDropDownList>
                            </div>
                        </div>
                        <div class="recording-toolbar-item recording-custom-date-wrap" *ngIf="customSearch">
                            <div class="recording-custom-date-row">
                                <span class="recording-date-field">
                                    <jqxDateTimeInput aria-hidden="true" (onValueChanged)="onStartDateValueChanged($event)"
                                        (onOpen)="startDateEventOpen($event)" [readonly]=true [min]="startmin"
                                        [max]="startmax" [value]="DisplayCustomStartDate" [width]="120" [height]="30"
                                        style="border-color: white;" [formatString]="'dd-MMM-yyyy'" theme="material">
                                    </jqxDateTimeInput>
                                </span>
                                <span class="recording-date-field">
                                    <jqxDateTimeInput aria-hidden="true" (onValueChanged)="onEndDateValueChanged($event)"
                                        [readonly]=true [min]="endmin" [value]="DisplayCustomEnddate" [max]="endmax"
                                        [width]="120" [height]="30" style="border-color: white;"
                                        [formatString]="'dd-MMM-yyyy'" theme="material">
                                    </jqxDateTimeInput>
                                </span>
                                <img class="recording-search-btn" src="../../../assets/img/icon/search-jobs.png" alt="Search Jobs"
                                    (click)='searchData()' textPosition="center">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive mt-4">
                    <jqxGrid id="recordings-grid" #myGrid [rendered]="labelRecordingGridFilters" (onPagechanged)="onPageChanged($event)"
                        (onRowdoubleclick)="onRowDoubleClick($event)" (onRowselect)="onRowSelect($event)"
                        (onRowunselect)="onRowUnselect($event)" (onFilter)="recordingGridFilter($event)"
                        [source]="sQLdataAdapter" [columns]="columns" [enabletooltips]="true" [virtualmode]="true"
                        [pagesize]="1000" [pagesizeoptions]="['100', '200', '1000']" [pageable]="true"
                        [rendergridrows]="rendergridrows" [theme]="'material'" [width]="'99.99%'" [height]="height"
                        [sortable]="true" [filterable]="true" [showfilterrow]="true" [showtoolbar]="true"
                        [toolbarheight]="40" [renderstatusbar]="createButtonsContainers"
                        [selectionmode]="'multiplerowsadvanced'" [columnsresize]="true" [columnsreorder]="true"
                        [pagerrenderer]="pagerrenderer" [autoshowloadelement]="false" [enablebrowserselection]="true"
                        [keyboardnavigation]="false" [scrollbarsize]="6">
                    </jqxGrid>
                </div>
            </div>
        </div>
    </div>
</div>
<jqxNotification #msgNotification [position]="'top-right'" [opacity]="1.0" [autoOpen]="false" [autoClose]="true"
    [animationOpenDelay]="800" [autoCloseDelay]="5000" template.success>
</jqxNotification>

<div *ngIf="isDetailWindowMode" class="vqc-fullpage-shell">
    <header class="vqc-fullpage-header">
        <h2 class="vqc-fullpage-title">Recording And Transcription</h2>
    </header>
    <ng-container [ngTemplateOutlet]="recordingDetailsContent"></ng-container>
</div>

<!-- <jqxWindow *ngIf="!isDetailWindowMode" #viewRecordingDetails [isModal]="false" [theme]="'material'"
    [title]="'Recording And Transcription'" (onClose)="onRecordingDetailsWindowClose()" [width]="windowWidth"
    [height]="windowHeight" [maxWidth]="2000" [maxHeight]="2000" [resizable]="true" [autoOpen]="false">
    <ng-container [ngTemplateOutlet]="recordingDetailsContent"></ng-container>
</jqxWindow> -->

<ng-template #recordingDetailsContent>

    <div class="vqc-window-wrapper">
        <!-- LEFT SIDEBAR -->
        <aside class="vqc-sidebar">
            <div class="vqc-sidebar-content" *ngIf="!showTimeline && !showAnnotationsPanel">
                <div class="vqc-case-panel" *ngIf="caseDetailRows.length > 0">
                    <div class="vqc-case-panel-header"
                        (click)="isCaseDetailsPanelExpanded = !isCaseDetailsPanelExpanded">
                        <span class="vqc-case-panel-title">Case Details ({{ caseDetailRows.length }})</span>
                        <span class="vqc-case-panel-caret">{{ isCaseDetailsPanelExpanded ? '&#9650;' : '&#9660;'
                            }}</span>
                    </div>

                    <div class="vqc-case-panel-body" *ngIf="isCaseDetailsPanelExpanded">
                        <div class="vqc-case-hint">When you select a case, the audio player and transcription will
                            adjust to that case.</div>

                        <div class="vqc-case-table-wrapper">
                            <table class="vqc-case-table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>{{ recordingCaseReferenceLabel }}</th>
                                        <th>Hearing Date/Time</th>
                                        <th>Start Time</th>
                                        <th>End Time</th>
                                        <th>Duration</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let caseRow of caseDetailRows"
                                        [class.selected]="selectedCaseDetail?.id === caseRow.id"
                                        (click)="selectCaseDetail(caseRow)">
                                        <td>
                                            <input type="radio" name="caseDetailRow"
                                                [checked]="selectedCaseDetail?.id === caseRow.id"
                                                (change)="selectCaseDetail(caseRow)" />
                                        </td>
                                        <td>{{ caseRow.caseNumber }}</td>
                                        <td>{{ caseRow.hearingDateTime | date:'EEE MMM dd yyyy HH:mm:ss' }}</td>
                                        <td>{{ caseRow.startedAt | date:'HH:mm:ss' }}</td>
                                        <td>{{ caseRow.stoppedAt ? (caseRow.stoppedAt | date:'HH:mm:ss') : '--:--:--'
                                            }}</td>
                                        <td>{{ caseRow.durationText }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="vqc-case-footer">Showing 1 to {{ caseDetailRows.length }} of {{
                            caseDetailRows.length }} cases</div>

                        <ng-container *ngIf="selectedCaseDetail as activeCase">
                            <div class="vqc-case-form" *ngIf="activeCase.formEntries.length > 0">
                                <h4 class="vqc-sidebar-section-title"
                                    style="margin-top: 10px; font-weight: bold; color: #4a5568;">Case Metadata:</h4>
                                <div class="vqc-meta-item" *ngFor="let entry of activeCase.formEntries">
                                    <div class="vqc-meta-label">{{ entry.label }}:</div>
                                    <div class="vqc-meta-value" style="word-break: break-all; color: #a0aec0;">
                                        {{ formatFormDataValue(entry) }}</div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <div class="vqc-sidebar-header">
                    <h3 class="vqc-sidebar-title">Recording Info:</h3>
                    <div *ngIf="selectedRecordingIsCourt" class="vqc-toggle-btn annotation-btn" (click)="openAnnotationPanel()" title="View Annotations">
                        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" fill="#1976d2"></path>
                            <path
                                d="M20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                                fill="#1976d2"></path>
                        </svg>
                    </div>
                    <div class="vqc-toggle-btn" (click)="showTimeline = true" title="Switch to Recording Timeline">
                        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                                fill="#1976d2"></path>
                        </svg>
                    </div>

                </div>

                <h4 class="vqc-sidebar-section-title" style="margin-top: 15px; font-weight: bold; color: #4a5568;">
                    Recorded File Info:</h4>

                <div class="vqc-meta-item">
                    <div class="vqc-meta-label">File Name:</div>
                    <div class="vqc-meta-value" style="word-break: break-all; color: #a0aec0;">
                        {{selectedRecording.fileName}}</div>
                </div>

                <div class="vqc-meta-item">
                    <div class="vqc-meta-label">Status:</div>
                    <div class="vqc-meta-value" style="color: #38a169; font-weight: 600;">
                        {{selectedRecording.status}}
                    </div>
                </div>

                <ng-container *ngIf="!selectedCaseDetail">
                    <div class="vqc-meta-item">
                        <div class="vqc-meta-label">File Path:</div>
                        <div class="vqc-meta-value" style="word-break: break-all; color: #a0aec0;">
                            {{selectedRecording.outputPath}}</div>
                    </div>

                    <div class="vqc-meta-item">
                        <div class="vqc-meta-label">Start Time:</div>
                        <div class="vqc-meta-value" style="color: #a0aec0;" *ngIf="selectedRecording?.startedAt">
                            {{selectedRecording.startedAt | date:'EEE MMMM dd yyyy HH:mm:ss'}}</div>
                    </div>

                    <div class="vqc-meta-item">
                        <div class="vqc-meta-label">End Time:</div>
                        <div class="vqc-meta-value" style="color: #a0aec0;">{{selectedRecording.stoppedAt | date:'EEE
                            MMMM dd yyyy HH:mm:ss'}}</div>
                    </div>

                    <div class="vqc-meta-item">
                        <div class="vqc-meta-label">Duration:</div>
                        <div class="vqc-meta-value" style="color: #a0aec0;">{{ formatTime(audioDuration) }}</div>
                    </div>

                    <div class="vqc-meta-item">
                        <div class="vqc-meta-label">Format:</div>
                        <div class="vqc-meta-value" style="color: #a0aec0;">{{selectedRecording.format}}</div>
                    </div>

                    <div class="vqc-meta-item">
                        <div class="vqc-meta-label">Audio Channels:</div>
                        <div class="vqc-meta-value" style="color: #a0aec0;">{{selectedRecording.audioChannels}}</div>
                    </div>

                    <ng-container *ngIf="formDetails.length">
                        <h4 class="vqc-sidebar-section-title"
                            style="margin-top: 15px; font-weight: bold; color: #4a5568;">
                            Metadata:</h4>

                        <div class="vqc-meta-item" *ngFor="let entry of formDetails">
                            <div class="vqc-meta-label">{{entry.label}}:</div>
                            <div class="vqc-meta-value" style="word-break: break-all; color: #a0aec0;">
                                {{formatFormDataValue(entry)}}</div>
                        </div>
                    </ng-container>
                </ng-container>

                <h4 class="vqc-sidebar-section-title" style="margin-top: 20px; font-weight: bold; color: #4a5568;">
                    Recorded Audio Configuration:</h4>

                <div class="vqc-meta-item">
                    <div class="vqc-meta-label">Microphone:</div>
                    <div class="vqc-meta-value" style="color: #a0aec0;">{{selectedRecording.microphone}}</div>
                </div>

                <div class="vqc-meta-item" *ngIf="selectedRecordingIsCourt">
                    <div class="vqc-meta-label">Court Location:</div>
                    <div class="vqc-meta-value" style="color: #a0aec0;">{{selectedRecording.courtLocation}}</div>
                </div>

                <div class="vqc-meta-item" *ngIf="selectedRecordingIsCourt">
                    <div class="vqc-meta-label">Courtroom:</div>
                    <div class="vqc-meta-value" style="color: #a0aec0;">{{selectedRecording.courtroom}}</div>
                </div>

                <div class="vqc-meta-item">
                    <div class="vqc-meta-label">Language:</div>
                    <div class="vqc-meta-value" style="color: #a0aec0;">{{selectedRecording.language}}</div>
                </div>

                <div class="vqc-meta-item">
                    <div class="vqc-meta-label">Translated to English:</div>
                    <div class="vqc-meta-value" style="color: #a0aec0;">{{selectedRecording.translateToEnglish}}</div>
                </div>

                <div class="vqc-meta-item">
                    <div class="vqc-meta-label">Transcription Status:</div>
                    <div class="vqc-meta-value" style="color: #a0aec0;">{{selectedRecording.transcriptionStatus}}</div>
                </div>
            </div>

            <div class="vqc-sidebar-content" *ngIf="showTimeline && !showAnnotationsPanel">
                <div class="vqc-sidebar-header">
                    <h3 class="vqc-sidebar-title">Recording Timeline:</h3>
                    <div *ngIf="selectedRecordingIsCourt" class="vqc-toggle-btn annotation-btn" (click)="openAnnotationPanel()" title="View Annotations">
                        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" fill="#1976d2"></path>
                            <path
                                d="M20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                                fill="#1976d2"></path>
                        </svg>
                    </div>
                    <div class="vqc-toggle-btn" (click)="showTimeline = false" title="Switch to Recording Info">
                        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                                fill="#1976d2"></path>
                        </svg>
                    </div>
                </div>

                <!-- <div class="vqc-timeline-legend">
            <div class="legend-row">
                <span class="legend-item"><span class="badge blue"></span> Active</span>
                <span class="legend-item"><span class="badge orange"></span> Paused</span>
            </div>
            <div class="legend-row">
                <span class="legend-item"><span class="badge green"></span> Start</span>
                <span class="legend-item"><span class="badge red"></span> End</span>
            </div>
        </div> -->
                <div class="vqc-timeline-legend">
                    <span class="legend-item"><span class="badge blue"></span> Active</span>
                    <span class="legend-item"><span class="badge orange"></span> Paused</span>
                    <span class="legend-item"><span class="badge green"></span> Start</span>
                    <span class="legend-item"><span class="badge red"></span> End</span>
                </div>

                <div class="vqc-timeline-container" *ngIf="parsedTimelineData">

                    <div class="timeline-endpoint">
                        <span class="endpoint-label">Started:</span>
                        <span class="endpoint-value">
                            {{ parsedTimelineData.AudioStart | date:'EEE MMMM dd yyyy HH:mm:ss' }}
                        </span>
                    </div>

                    <div class="timeline-visual-track">

                        <div class="track-node">
                            <span class="node-time">{{ parsedTimelineData.AudioStart | date:'HH:mm:ss' }}</span>
                            <div class="node-bar green-bar" title="Recording Started"></div>
                            <span class="node-status strong-text">Active <small class="text-muted">{{
                                    calculateDuration(parsedTimelineData.AudioStart, timelineEvents[0]?.Time ||
                                    parsedTimelineData.AudioEnd) }}</small></span>
                        </div>

                        <ng-container *ngFor="let event of timelineEvents; let i = index">
                            <div class="track-node">
                                <span class="node-time">{{ event.Time | date:'HH:mm:ss' }}</span>

                                <div class="node-bar"
                                    [ngClass]="{'orange-bar': event.Action === 'Paused', 'blue-bar': event.Action === 'Resumed'}"
                                    [title]="event.Action">
                                </div>

                                <span class="node-status">
                                    {{ event.Action === 'Resumed' ? 'Active' : 'Paused' }}
                                    <small class="text-muted">
                                        {{ calculateDuration(event.Time, timelineEvents[i+1]?.Time ||
                                        parsedTimelineData.AudioEnd) }}
                                    </small>
                                </span>
                            </div>
                        </ng-container>

                        <div class="track-node">
                            <span class="node-time">{{ parsedTimelineData.AudioEnd | date:'HH:mm:ss' }}</span>
                            <div class="node-bar red-bar" title="Recording Ended"></div>
                        </div>

                    </div>

                    <div class="timeline-endpoint" style="margin-top: 15px;">
                        <span class="endpoint-label">Ended:</span>
                        <span class="endpoint-value">
                            {{ parsedTimelineData.AudioEnd | date:'EEE MMMM dd yyyy HH:mm:ss' }}
                        </span>
                    </div>

                </div>
            </div>

            <div class="vqc-sidebar-content" *ngIf="showAnnotationsPanel">
                <div class="vqc-sidebar-header">
                    <h3 class="vqc-sidebar-title">Annotations</h3>
                    <div class="vqc-toggle-btn" (click)="closeAnnotationPanel()" title="Back to previous view">
                        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path d="M19 12H5M12 19l-7-7 7-7" stroke="#1976d2" stroke-width="2" fill="none"
                                stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </div>
                </div>

                <div class="annotation-panel">
                    <app-annotation #annotationComp [recordingId]="selectedRecording.id"
                        [recordingDuration]="formatTime(audioCurrentTime)"
                        [caseDetailsId]="selectedCaseDetail?.id || null"
                        [speakers]="annotationSpeakers"
                        [autoStartTranscription]="autoStartTranscription"
                        [postRecordingAnnotationUpdate]="selectedRecording.postRecordingAnnotationUpdate"
                        [startDate]="selectedRecording.startedAt" [class.fullscreen]="isAnnotationMaximized"
                        (toggleMaximize)="setAnnotationDetailVisibility($event)"
                        (updateAudioPosition)="setAudioPlayerPosition($event)">
                    </app-annotation>
                </div>
            </div>
        </aside>

        <!-- RIGHT PANEL -->
        <main class="vqc-main-panel">
            <div class="vqc-main-scroll">

                <div class="vqc-case-banner" *ngIf="selectedCaseDetail as activeCase">
                    <span class="vqc-case-banner-main"><strong>Now viewing:</strong> Case {{ activeCase.caseNumber
                        }}</span>
                    <span class="vqc-case-banner-note">Audio player and transcription are adjusted to this case.</span>
                    <button type="button" class="vqc-case-banner-clear" (click)="clearCaseSelection()">Show full
                        recording</button>
                </div>

                <!-- Text Area: styled to match transcription container in main audiostreaming view -->
                <div class="player-container">
                    <audio #audioRef style="display:none;" controlsList="nodownload"
                        (loadedmetadata)="onAudioLoadedMetadata()" (timeupdate)="onAudioTimeUpdate()"
                        (ended)="onAudioEnded()">
                    </audio>

                    <div class="player-time-labels">
                        <span>{{ playbackStartDate | date:'EEE MMMM dd yyyy HH:mm:ss' }}</span>
                        <span>{{ formatTime(playbackDuration) }}</span>
                        <span>{{ playbackEndDate | date:'EEE MMMM dd yyyy HH:mm:ss' }}</span>
                    </div>

                    <div class="timeline-slider-wrapper">
                        <input type="range" id="timelineSlider" class="timeline-slider" step="0.1" aria-label="Recording playback position"
                            [min]="playbackStart" [max]="playbackEnd" [value]="audioCurrentTime || 0"
                            (input)="seekTo($any($event.target).value)" />
                    </div>

                    <div class="duration-counters">
                        <!-- Shows actual time based on startedAt (e.g. 17:00:00 -> 17:03:40) -->
                        <span>{{ formatClockTime(audioCurrentTime) }}</span>

                        <div class="control-group-center">
                            <div class="media-controls-container">
                                <button type="button" class="rec-mute-btn rec-action-btn" matTooltip="Rewind 10 seconds"
                                    matTooltipClass="player-control-tooltip" aria-label="Rewind 10 seconds" (click)="skipAudio(-10)">
                                    <i class="material-icons" aria-hidden="true">replay_10</i>
                                </button>

                                <button type="button" class="rec-circle-btn rec-action-btn"
                                    [matTooltip]="isAudioPlaying ? 'Pause playback' : 'Play recording'"
                                    matTooltipClass="player-control-tooltip"
                                    [attr.aria-label]="isAudioPlaying ? 'Pause playback' : 'Play recording'"
                                    (click)="toggleAudioPlayPause()">
                                    <i class="material-icons" aria-hidden="true">{{ isAudioPlaying ? 'pause' : 'play_arrow' }}</i>
                                </button>

                                <button type="button" class="rec-mute-btn rec-action-btn" matTooltip="Forward 10 seconds"
                                    matTooltipClass="player-control-tooltip" aria-label="Forward 10 seconds" (click)="skipAudio(10)">
                                    <i class="material-icons" aria-hidden="true">forward_10</i>
                                </button>
                            </div>
                            <div class="volume-container" title="Volume control">
                                <button type="button" class="rec-mute-btn rec-action-btn" id="muteBtn"
                                    [class.muted]="audioVolume === 0" [attr.aria-pressed]="audioVolume === 0"
                                    [matTooltip]="audioVolume > 0 ? 'Mute playback' : 'Unmute playback'"
                                    matTooltipClass="player-control-tooltip"
                                    [attr.aria-label]="audioVolume > 0 ? 'Mute playback' : 'Unmute playback'"
                                    (click)="toggleMute()">
                                    <i class="material-icons" aria-hidden="true">{{ audioVolume > 0 ? 'volume_up' : 'volume_off' }}</i>
                                </button>
                                <input id="volumeSlider" class="volume-slider" type="range" aria-label="Playback volume" min="0" max="1" step="0.01"
                                    [value]="audioVolume" (input)="onVolumeChange($event)" />
                            </div>
                            <button type="button" class="rec-mute-btn rec-action-btn" [matMenuTriggerFor]="playbackChannelsMenu"
                                (menuOpened)="attachPlaybackChannels()"
                                matTooltip="Playback channels" matTooltipClass="player-control-tooltip"
                                aria-label="Show playback channels">
                                <i class="material-icons" aria-hidden="true">graphic_eq</i>
                            </button>
                            <mat-menu #playbackChannelsMenu="matMenu" class="channel-mixer-menu" yPosition="above">
                                <ng-template matMenuContent>
                                    <app-channel-strips [mixer]="playbackChannels.mixer" [active]="isAudioPlaying"></app-channel-strips>
                                </ng-template>
                            </mat-menu>
                        </div>

                        <!-- Total duration without pause gaps -->
                        <span>{{ playbackEndDate | date:'HH:mm:ss' }}</span>
                    </div>
                </div>
                <div class="transcription-info transcription-toolbar-row">
                    <div class="transcription-info-details">
                        <span><strong>Words:</strong> {{ wordCount }}</span>
                        <span><strong>Characters:</strong> {{ characterCount }}</span>
                        <span><strong>Last Updated:</strong> <span *ngIf="lastUpdated">{{ lastUpdated | date:'EEE MMMM dd
                                yyyy HH:mm:ss' }}</span></span>
                    </div>

                    <div *ngIf="HaveTranscription" class="transcription-toolbar-buttons">
                        <span *ngIf="!isTranscriptionEditMode" class="mode-badge">👁️ Viewing</span>
                        <span *ngIf="isTranscriptionEditMode" class="mode-badge editing-badge">✏️ Editing</span>
                        <button *ngIf="isTranscriptionEditMode" class="toolbar-icon-btn save-icon"
                            title="Save transcription" (click)="saveTranscriptionEdits()">💾</button>
                        <button *ngIf="isTranscriptionEditMode" class="toolbar-icon-btn cancel-icon"
                            title="Cancel editing" (click)="cancelTranscriptionEdits()">✖️</button>
                        <button *ngIf="!isTranscriptionEditMode && allowTranscriptEditing"
                            class="toolbar-icon-btn edit-icon" title="Edit transcription"
                            (click)="enterTranscriptionEditMode()">✏️</button>
                        <button  class="toolbar-icon-btn summary-icon" title="View summary"
                            (click)="generateTranscriptionSummary()">📋</button>
                        <button  class="toolbar-icon-btn download-icon" title="Download transcription"
                            (click)="downloadTranscriptionDocx()" [disabled]="!HaveTranscription" [attr.aria-disabled]="!HaveTranscription">📥</button>
                    </div>
                </div>

                <!-- Froala Editor Container -->
                <div class="transcription-container">
                    <!-- Read-only View Mode -->
                    <div [hidden]="isTranscriptionEditMode" class="froala-view-mode">
                        <div #transcriptionDisplay class="transcription-display">
                            <div *ngIf="transcriptionDisplayHtml; else emptyState"
                                [innerHTML]="sanitizedTranscriptionContent">
                            </div>

                            <ng-template #emptyState>
                                <div style="color: #a0aec0; text-align: center; padding: 40px 0;">
                                    <p *ngIf="!selectedCaseDetail">No transcription available for this recording.</p>
                                    <p *ngIf="selectedCaseDetail">No transcription available for the selected case.</p>
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <!-- Edit Mode: Froala Editor (Uses [hidden] to keep DOM initialized) -->
                    <div [hidden]="!isTranscriptionEditMode" class="froala-edit-mode">
                        <jqxWindow #findReplacePopup [width]="520" [height]="260" [autoOpen]="false" [resizable]="false"
                            [showCloseButton]="false" [position]="'center'">
                            <div
                                style="padding: 12px; font-weight: 600; border-bottom: 1px solid #e5e7eb; margin-bottom: 10px;">
                                Find and Replace
                            </div>
                            <div style="padding: 0 12px 12px;">
                                <div
                                    style="display: flex; gap: 8px; flex-wrap: wrap; align-items: center; margin-bottom: 10px;">
                                    <input type="text" [(ngModel)]="findWhatText" placeholder="Find"
                                        style="flex: 1; min-width: 200px; padding: 8px 10px; border: 1px solid #cbd5e1; border-radius: 4px;" />
                                    <input type="text" [(ngModel)]="replaceWithText" placeholder="Replace with"
                                        style="flex: 1; min-width: 200px; padding: 8px 10px; border: 1px solid #cbd5e1; border-radius: 4px;" />
                                </div>
                                <div
                                    style="display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 10px; font-size: 13px; color: #4b5563;">
                                    <label style="display: flex; align-items: center; gap: 4px;">
                                        <input type="checkbox" [(ngModel)]="isFindReplaceCaseSensitive" /> Case
                                        sensitive
                                    </label>
                                    <label style="display: flex; align-items: center; gap: 4px;">
                                        <input type="checkbox" [(ngModel)]="isFindReplaceMatchWord" /> Whole word
                                    </label>
                                </div>
                                <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                                    <button type="button" (click)="onFindText()"
                                        style="padding: 7px 12px; border: 0; border-radius: 4px; background: #1976d2; color: white; cursor: pointer;">Find</button>
                                    <button type="button" (click)="onReplace()"
                                        style="padding: 7px 12px; border: 0; border-radius: 4px; background: #2f855a; color: white; cursor: pointer;">Replace</button>
                                    <button type="button" (click)="onReplaceAll()"
                                        style="padding: 7px 12px; border: 0; border-radius: 4px; background: #805ad5; color: white; cursor: pointer;">Replace
                                        All</button>
                                    <button type="button" (click)="closeFindReplacePanel()"
                                        style="padding: 7px 12px; border: 0; border-radius: 4px; background: #4b5563; color: white; cursor: pointer;">Close</button>
                                </div>
                            </div>
                        </jqxWindow>

                        <!-- Froala Editor -->
                        <textarea [froalaEditor]="froalaOptions" [(ngModel)]="editableTranscriptionContent"
                            placeholder="Edit transcription here..." style="min-height: 400px; width: 100%;">
    </textarea>
                    </div>
                </div>
                <jqxWindow #summaryWindow [width]="1000" [height]="600" [isModal]="true" [autoOpen]="false"
                    [resizable]="true" [theme]="'material'" [title]="'Document Summary'"
                    (onClose)="onSummaryWindowClose()">
                    <div class="window-container">
                        <div class="row">
                            <div class="col-md-6">
                                <mat-radio-group class="prompt-radio-cards" [(ngModel)]="promptMode">
                                    <mat-radio-button value="summary" class="radio-card custom-radio"
                                        (change)="onSelectedRadioButton($event)">Preset Prompt</mat-radio-button>
                                    <mat-radio-button *ngIf="showCustomPrompt" value="custom"
                                        class="radio-card custom-radio" (change)="onSelectedRadioButton($event)">Custom
                                        Prompt</mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <div class="col-md-6">
                                <div *ngIf="promptMode === 'summary' && (presetPromptsOptions?.length ?? 0) <= 1"
                                    class="row" style="padding: 2%;">
                                    <label id="mylabel" class="font-red-shade">
                                        Create/Need a Prompt to Generate the Summary.
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="promptMode === 'summary'" class="row" style="padding: 2%;">
                            <div class="col-md-12">
                                <mat-label>Summary Prompts</mat-label>
                                <jqxDropDownList #summaryPromptDDL [theme]="'material'" [width]="'100%'" [height]="30"
                                    style="margin-left: -0.5%;" [autoDropDownHeight]="true"
                                    [source]="presetPromptsOptions" [displayMember]="'PromptText'"
                                    [valueMember]="'PromptId'" [selectedIndex]="0" (onSelect)="onSummarySelect($event)">
                                </jqxDropDownList>
                            </div>
                        </div>
                        <div *ngIf="promptMode === 'custom'" class="row" style="padding: 2%;">
                            <div class="col-md-12">
                                <mat-form-field class="example-full-width">
                                    <mat-label>Custom prompt</mat-label>
                                    <textarea #customPrompt matInput rows="2" [(ngModel)]="customPromptText"
                                        (ngModelChange)="onCustomPromptChange($event)">
                    </textarea>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="window-content">
                            {{ summaryText }}
                        </div>
                        <div class="window-footer summary-footer-buttons">
                            <button class="btn-with-icon pull-right ml-1" [hidden]="!summaryText"
                                (click)="downloadSummary()" title="Download summary">
                                <svg class="icon-svg" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                                </svg>
                                <span>Download</span>
                            </button>

                            <button class="btn-with-icon pull-right ml-1" [hidden]="!summaryText"
                                (click)="copyToClipboard()" title="Copy summary">
                                <svg class="icon-svg" viewBox="0 0 24 24" aria-hidden="true">
                                    <path
                                        d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                                </svg>
                                <span>Copy</span>
                            </button>

                            <button class="btn-with-icon pull-right ml-1" [hidden]="summaryText" (click)="getSummary()"
                                title="Generate summary">
                                <svg class="icon-svg" viewBox="0 0 24 24" aria-hidden="true">
                                    <path
                                        d="M9.5 11C11 11 12.3 11.6 13.2 12.6L14.6 11.2C13.3 9.9 11.5 9 9.5 9C6 9 3.1 11.9 3.1 15.4C3.1 18.9 6 21.8 9.5 21.8C13 21.8 15.9 18.9 15.9 15.4C15.9 13.4 15 11.6 13.7 10.3L12.3 11.7C13.3 12.6 14 13.9 14 15.4C14 18 11.6 20.4 9 20.4C6.4 20.4 4 18 4 15.4C4 12.8 6.4 10.4 9 10.4C9.1 10.4 9.3 10.4 9.5 10.4V11z" />
                                </svg>
                                <span>Get Summary</span>
                            </button>
                        </div>
                    </div>
                </jqxWindow>
            </div>
        </main>
    </div>
</ng-template>